import { CmsObjectWithDefault } from '@components/Cms/types';

export type LoginPanelCmsKey =
    | 'SignInTitle'
    | 'TermsOfUse'
    | 'PrivacyPolicy'
    | 'BySigningIn_IAgreeToAgoda'
    | 'SignInSubtitle'
    | 'OrSignInWith'
    | 'HateRemembering'
    | 'BySigningUpYouAgreeToAgodaX'
    | 'ByLoggingInPartnerCenter'
    | 'BySigningUpPartnerCenter'
    | 'ByUsingYcs'
    | 'ByLoggingInRocketmiles'
    | 'ExpiredMagicLink';

export const LoginPanelCmsWithDefault: CmsObjectWithDefault<LoginPanelCmsKey> = {
    SignInTitle: {
        cmsId: 67372,
        defaultTranslation: 'Sign in',
    },
    TermsOfUse: {
        cmsId: 73927,
        defaultTranslation: 'Terms of Use',
    },
    PrivacyPolicy: {
        cmsId: 73928,
        defaultTranslation: 'Privacy Policy',
    },
    BySigningIn_IAgreeToAgoda: {
        cmsId: 73926,
        defaultTranslation: "By signing in, I agree to Agoda's {0} and {1}.",
    },
    SignInSubtitle: {
        cmsId: 67373,
        defaultTranslation: 'For security, please sign in to access your information',
    },
    OrSignInWith: {
        cmsId: 121349,
        defaultTranslation: 'or sign in with',
    },
    HateRemembering: {
        cmsId: 77708,
        defaultTranslation: "Hate remembering your Agoda password? Login with Facebook now and you'll never have to!",
    },
    BySigningUpYouAgreeToAgodaX: {
        cmsId: 83673,
        defaultTranslation: "By signing up you agree to Agoda's {0}.",
    },
    ByLoggingInPartnerCenter: {
        cmsId: 96928,
        defaultTranslation: 'By logging in, you accept our {0}, and {1}',
    },
    BySigningUpPartnerCenter: {
        cmsId: 96927,
        defaultTranslation: 'By signing up, you accept our {0}, and {1}',
    },
    ByUsingYcs: {
        cmsId: 127072,
        defaultTranslation: "By using YCS website, I agree to Agoda's {0}",
    },
    ByLoggingInRocketmiles: {
        cmsId: 281231,
        defaultTranslation: 'By using Rocketmiles website, you accept our {0} and {1}',
    },
    ExpiredMagicLink: {
        cmsId: 316158,
        defaultTranslation: 'This verification link is invalid or has already been used',
    },
};
